export interface EvaluationType {
	id: number;
	name: string;
	description: string;
	sort_order: number;
}

export interface EvaluationCriterion {
	id: number;
	name: string;
	created_at?: string;
	description: string | null;
	evaluation_type?: EvaluationType;
	rfx_evaluation_type_id: number;
	rfx_id: number;
	sort_order: number;
	updated_at?: string;
	weight: number;
}

export interface CreateCriterionPayload {
	name: string;
	description?: string;
	rfx_evaluation_type_id: number;
	weight: number;
}

export interface UpdateCriterionPayload extends CreateCriterionPayload {
	id: number;
}

export interface CopyCriteriaPayload {
	criteria_ids: number[];
}

export interface CriteriaSearchResult {
	criteria: EvaluationCriterion[];
	rfx_id: number;
	rfx_name: string;
}

export const EVALUATION_TYPE_OPTIONS: { label: string; value: number; }[] = [
	{ value: 1, label: "Price" },
	{ value: 2, label: "Technical" },
	{ value: 3, label: "Experience" },
	{ value: 4, label: "Qualitative" },
	{ value: 5, label: "Quantitative" },
	{ value: 6, label: "Compliance" },
	{ value: 7, label: "Sustainability" },
	{ value: 8, label: "Team" },
	{ value: 9, label: "Other" },
];
